import React from 'react';

export default class SelectInput extends React.PureComponent {
  componentDidMount() {
    // below is a hack for a bug in edge related to form submitting.
    // see: https://github.com/facebook/react/issues/7655
    if (window.navigator.userAgent.indexOf('Edge') > -1) {
      let selectedIndex = -1;
      if (this._input) {
        selectedIndex = this._input.selectedIndex;
      }
      if (selectedIndex >= 0) {
        let tempOption;
        if (this._input.childNodes.length === 1) {
          tempOption = document.createElement('option');
          this._input.appendChild(tempOption);
        }
        const options = this._input.options;
        const tempIndex = (selectedIndex + 1) % options.length;
        options[tempIndex].selected = true;
        options[selectedIndex].selected = true;
        if (tempOption) {
          this._input.removeChild(tempOption);
        }
      }
    }
  }
  render() {
    return (
      <select ref={n => this._input = n} {...this.props}>
        {this.props.children}
      </select>
    );
  }
}
